import { useTranslation } from 'react-i18next';
import { IBenefit } from '@/common/integrations/menhir/employee/benefits/benefits.types';
import { IconCheck, Text } from '@coverflex-tech/hypernova';
import css from './ExampleStep.module.css';

interface IProps {
  benefit: IBenefit;
}

export const ExampleStep = ({ benefit }: IProps) => {
  const { t } = useTranslation();

  const examplePoints =
    (t(`learning_centre.${benefit?.slug}.example.points`, {
      returnObjects: true,
    }) as string[]) ?? [];

  const eligiblePoints =
    (t(`learning_centre.${benefit?.slug}.eligible.points`, {
      returnObjects: true,
    }) as string[]) ?? [];

  return (
    <div className={css.content}>
      <div>
        <Text bold className={css.title}>
          {t(`learning_centre.${benefit.slug}.example.title`)}
        </Text>
        <Text>{t(`learning_centre.${benefit.slug}.example.description`)}</Text>
        <div className={css.bullets}>
          {examplePoints.map((point, index) => (
            <div className={css.bullet} key={index}>
              <IconCheck className={css.point} />
              <Text>{point}</Text>
            </div>
          ))}
        </div>
      </div>
      <div>
        <Text bold className={css.title}>
          {t(`learning_centre.${benefit.slug}.eligible.title`)}
        </Text>
        <Text>{t(`learning_centre.${benefit.slug}.eligible.description`)}</Text>
        <div className={css.bullets}>
          {eligiblePoints &&
            eligiblePoints.map((point, index) => (
              <div className={css.bullet} key={index}>
                <IconCheck className={css.point} />
                <Text>{point}</Text>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
